import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

export default function(selector = '.js-swiper-carousel') {

  function initSwiper(element){

    let defaultSettings = {
        slidesPerView: 1,
        spaceBetween: 30,
        autoHeight: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
    }

    return new Swiper(element, defaultSettings);
  }

  document.querySelectorAll(selector).forEach((element) => {
    initSwiper(element);
  });
}
